import Cookies from 'js-cookie';

/*

handleError있으면 JSON으로 상태값전달

fetchDefault('/BranchData/GetBranchList',
    (data) => {});

fetchDefault('/BranchData/GetBranchList',
    (data) => {},
    (error) => alert(error.message));

*/
export function fetchDefault(requestInfo, handleData, handleError) {
    
    fetch(requestInfo, {
            headers: {
                Authorization: 'Bearer ' + Cookies.get("JWT")
            }
        })
        .then(response => handleFetchResponse(response, handleError ? false : true))
        .then(data => {
            if (handleData != null) {
                handleData(data);
            }
        })
        .catch(error => {
            if (handleError) {
                handleError(error);
            } else {
                if (error != 'TypeError: Failed to fetch') {
                    alert(error);
                }
            }
        });
}

export function fetchPostDefault(requestInfo, requestInit, handleData, handleError) {

    fetch(requestInfo, {
            method: 'POST',
            body: JSON.stringify(requestInit),
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + Cookies.get("JWT")
            },
        })
        .then(response => handleFetchResponse(response, handleError ? false : true))
        .then(data => {
            if (handleData != null) {
                handleData(data);
            }
        })
        .catch(error => {
            if (handleError) {
                handleError(error);
            } else {
                alert(error);
            }
        });
}

export function handleFetchResponse(response, isDefaultError) {
    if (!response.ok) {
        if (response.status === 401) {
            localStorage.setItem("lastPage", window.location.href);
            window.location.href = '/display/connected';
            //throw new Error('unauthorized');
        } else {

            if (isDefaultError) {
                return response.text()
                    .then(error => { throw error; });
            } else {
                return response.json()
                    .then(error => { throw error; });
            }
        }
    } else {
        return response.json();
    }
}


export function getNowTimeStamp() {
    var d = new Date();
    var s =
        leadingZeros(d.getFullYear(), 4) + '-' +
        leadingZeros(d.getMonth() + 1, 2) + '-' +
        leadingZeros(d.getDate(), 2) + 'T' +

        leadingZeros(d.getHours(), 2) + ':' +
        leadingZeros(d.getMinutes(), 2)

    return s;
}

function leadingZeros(n, digits) {
    var zero = '';
    n = n.toString();

    if (n.length < digits) {
        for (let i = 0; i < digits - n.length; i++)
            zero += '0';
    }
    return zero + n;
}


// WEBPACK FOOTER //
// ./src/components/Utils.js